import React from 'react';

type Props = {
  onClose: () => void;
  onApply: () => void;
  onReset: () => void;
  filters: {
    gender: string;
    experience: string;
    schedule: null | string | number;
  };
  setFilters: (f: any) => void;
};

const DoctorFilterBottomSheet: React.FC<Props> = ({ onClose, onApply, onReset, filters, setFilters }) => {
  const genderOptions = [
    { label: 'Laki-Laki', value: 'male' },
    { label: 'Perempuan', value: 'female' }
  ];

  const experienceOptions = [
    { label: 'Kurang dari 5 tahun', value: '5' },
    { label: '5 - 10 tahun', value: '5,10' },
    { label: 'Lebih dari 10 tahun', value: '10' }
  ];

  const scheduleOptions = [
    { label: 'Online', value: 1 },
    { label: 'Offline', value: 0 }
  ];
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white z-50 rounded-t-2xl shadow-xl px-4 py-6 z-50 max-h-[80vh] overflow-y-auto">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-md font-semibold">Filter</h3>
        <button onClick={onClose} className="text-gray-400 text-xl">&times;</button>
      </div>

      {/* Jenis Kelamin */}
      <div className="mb-4">
        <p className="text-sm font-semibold mb-2">Jenis Kelamin</p>
        <div className="flex flex-col gap-2">
          {genderOptions.map((g) => (
            <label key={g.value} className="flex items-center gap-2">
              <input
                type="radio"
                name="gender"
                value={g.value}
                checked={filters.gender === g.value}
                onChange={() => setFilters({ ...filters, gender: g.value })}
              />
              <span>{g.label}</span>
            </label>
          ))}
        </div>
      </div>

      {/* Pengalaman */}
      <div className="mb-4">
        <p className="text-sm font-semibold mb-2">Pengalaman</p>
        <div className="flex flex-col gap-2">
          {experienceOptions.map((e) => (
            <label key={e.value} className="flex items-center gap-2">
              <input
                type="radio"
                name="experience"
                value={e.value}
                checked={filters.experience === e.value}
                onChange={() => setFilters({ ...filters, experience: e.value })}
              />
              <span>{e.label}</span>
            </label>
          ))}
        </div>
      </div>

      {/* Jadwal */}
      <div className="mb-6">
        <p className="text-sm font-semibold mb-2">Jadwal</p>
        <div className="flex flex-col gap-2">
          {scheduleOptions.map((s) => (
            <label key={s.value} className="flex items-center gap-2">
              <input
                type="radio"
                name="schedule"
                value={s.value}
                checked={filters.schedule === s.value}
                onChange={() => setFilters({ ...filters, schedule: s.value })}
              />
              <span>{s.label}</span>
            </label>
          ))}
        </div>
      </div>

      {/* Buttons */}
    <div className="sticky bottom-0 left-0 bg-white pt-4 pb-16 mt-4 px-2 flex justify-between gap-4">
        <button
          onClick={onReset}
          className="w-full border border-morning-300 text-morning-300 py-2 rounded-full text-sm font-medium"
        >
          Reset
        </button>
        <button
          onClick={onApply}
          className="w-full bg-morning-300 text-white py-2 rounded-full text-sm font-medium"
        >
          Terapkan
        </button>
      </div>
    </div>
  );
};

export default DoctorFilterBottomSheet;
